export default {
  // Basic pages
  'pages.layouts.userLayout.title': 'Ant Design là bộ quy chuẩn thiết kế web có ảnh hưởng nhất tại QLTE',
  'pages.login.accountLogin.tab': 'Đăng nhập bằng tài khoản',
  'pages.login.accountLogin.errorMessage': 'Tên đăng nhập/mật khẩu không đúng (admin/ant.design)',
  'pages.login.failure': 'Đăng nhập thất bại, vui lòng thử lại!',
  'pages.login.success': 'Đăng nhập thành công!',
  'pages.login.username.placeholder': 'Tên đăng nhập: admin hoặc user',
  'pages.login.username.required': 'Vui lòng nhập tên đăng nhập!',
  'pages.login.password.placeholder': 'Mật khẩu: ant.design',
  'pages.login.password.required': 'Vui lòng nhập mật khẩu!',
  'pages.login.phoneLogin.tab': 'Đăng nhập bằng điện thoại',
  'pages.login.phoneLogin.errorMessage': 'Mã xác minh không đúng',
  'pages.login.phoneNumber.placeholder': 'Số điện thoại',
  'pages.login.phoneNumber.required': 'Vui lòng nhập số điện thoại!',
  'pages.login.phoneNumber.invalid': 'Số điện thoại không hợp lệ!',
  'pages.login.captcha.placeholder': 'Mã xác minh',
  'pages.login.captcha.required': 'Vui lòng nhập mã xác minh!',
  'pages.login.phoneLogin.getVerificationCode': 'Lấy mã',
  'pages.getCaptchaSecondText': 'giây',
  'pages.login.rememberMe': 'Ghi nhớ đăng nhập',
  'pages.login.forgotPassword': 'Quên mật khẩu?',
  'pages.login.submit': 'Đăng nhập',
  'pages.login.loginWith': 'Đăng nhập bằng:',
  'pages.login.registerAccount': 'Đăng ký tài khoản',
  'pages.welcome.link': 'Chào mừng',
  'pages.welcome.alertMessage': 'Các thành phần mạnh mẽ và hiệu suất cao đã được phát hành.',
  'pages.404.subTitle': 'Xin lỗi, trang bạn truy cập không tồn tại.',
  'pages.404.buttonText': 'Về trang chủ',
  'pages.admin.subPage.title': 'Trang này chỉ dành cho Admin',
  'pages.admin.subPage.alertMessage': 'Umi UI đã được phát hành, hãy chạy "npm run ui" để trải nghiệm.',

  // Search table
  'pages.searchTable.createForm.newRule': 'Tạo quy tắc mới',
  'pages.searchTable.updateForm.ruleConfig': 'Cấu hình quy tắc',
  'pages.searchTable.updateForm.basicConfig': 'Thông tin cơ bản',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Tên quy tắc',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Nhập tên quy tắc!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Mô tả',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Nhập tối thiểu 5 ký tự',
  'pages.searchTable.updateForm.ruleDesc.descRules': 'Mô tả cần ít nhất 5 ký tự!',
  'pages.searchTable.updateForm.ruleProps.title': 'Thuộc tính',
  'pages.searchTable.updateForm.object': 'Đối tượng',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Mẫu quy tắc',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Loại quy tắc',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Chu kỳ chạy',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Thời gian bắt đầu',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Chọn thời gian bắt đầu!',
  'pages.searchTable.schedulingPeriod.title': 'Chu kỳ chạy',
  'pages.searchTable.titleDesc': 'Mô tả',
  'pages.searchTable.ruleName': 'Tên quy tắc',
  'pages.searchTable.titleCallNo': 'Lượt gọi',
  'pages.searchTable.titleStatus': 'Trạng thái',
  'pages.searchTable.nameStatus.default': 'mặc định',
  'pages.searchTable.nameStatus.running': 'đang chạy',
  'pages.searchTable.nameStatus.online': 'trực tuyến',
  'pages.searchTable.nameStatus.abnormal': 'bất thường',
  'pages.searchTable.titleUpdatedAt': 'Chạy lần cuối',
  'pages.searchTable.updatedAt': 'Cập nhật',
  'pages.searchTable.exception': 'Nhập lý do ngoại lệ!',
  'pages.searchTable.titleOption': 'Tùy chọn',
  'pages.searchTable.config': 'Cấu hình',
  'pages.searchTable.update': 'Cập nhật',
  'pages.searchTable.clone': 'Sao chép',
  'pages.searchTable.subscribeAlert': 'Nhận cảnh báo',
  'pages.searchTable.title': 'Tra cứu',
  'pages.searchTable.new': 'Thêm mới',
  'pages.searchTable.chosen': 'đã chọn',
  'pages.searchTable.item': 'mục',
  'pages.searchTable.totalServiceCalls': 'Tổng lượt gọi',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'Xóa nhiều',
  'pages.searchTable.batchApproval': 'Duyệt nhiều',
  'pages.searchTable.delete': 'Xóa',
  'pages.searchTable.print': 'In',

  // Common
  'pages.delete.confirm': 'Bạn chắc chắn muốn xóa?',
  'pages.delete.ok': 'Xóa',
  'pages.delete.cancel': 'Hủy',
  'pages.common.noPermission': 'Bạn không có quyền này',
  'common.yes': 'Có',
  'common.no': 'Không',

  // Query Filter Labels
  'pages.queryFilter.label.customerId': 'Khách hàng',
  'pages.queryFilter.label.supplierId': 'Nhà cung cấp',
  'pages.queryFilter.label.productId': 'Sản phẩm',
  'pages.queryFilter.label.code': 'Mã',
  'pages.queryFilter.label.sourceType': 'Nguồn',
  'pages.queryFilter.label.status': 'Trạng thái',
  'pages.queryFilter.label.inspectionType': 'Loại kiểm tra',
  'pages.queryFilter.label.requestedAtFrom': 'Ngày yêu cầu (Từ)',
  'pages.queryFilter.label.requestedAtTo': 'Ngày yêu cầu (Đến)',
  'pages.queryFilter.label.targetDateFrom': 'Hạn chót (Từ)',
  'pages.queryFilter.label.targetDateTo': 'Hạn chót (Đến)',

  // Source Transaction
  'pages.sourceTransaction.title': 'Giao dịch nguồn',
  'pages.sourceTransaction.code': 'Mã giao dịch',
  'pages.sourceTransaction.date': 'Ngày',
  'pages.sourceTransaction.sourceType': 'Nguồn',
  'pages.sourceTransaction.customerName': 'Khách hàng',
  'pages.sourceTransaction.customerId': 'Khách hàng',
  'pages.sourceTransaction.supplierName': 'Nhà cung cấp',
  'pages.sourceTransaction.supplierId': 'Nhà cung cấp',
  'pages.sourceTransaction.productName': 'Sản phẩm',
  'pages.sourceTransaction.productId': 'Sản phẩm',
  'pages.sourceTransaction.uomName': 'ĐVT',
  'pages.sourceTransaction.uomId': 'Đơn vị tính',
  'pages.sourceTransaction.colorName': 'Màu',
  'pages.sourceTransaction.colorId': 'Màu',
  'pages.sourceTransaction.sizeName': 'Size',
  'pages.sourceTransaction.sizeId': 'Size',
  'pages.sourceTransaction.destinationName': 'Điểm đến',
  'pages.sourceTransaction.destinationId': 'Điểm đến',
  'pages.sourceTransaction.operationLibraryDetailName': 'Chi tiết thư viện thao tác',
  'pages.sourceTransaction.operationLibraryDetailId': 'Chi tiết thư viện thao tác',
  'pages.sourceTransaction.quantity': 'Số lượng',
  'pages.sourceTransaction.orderQuantity': 'SL đơn hàng',
  'pages.sourceTransaction.offeredQuantity': 'SL giao',
  'pages.sourceTransaction.fiDate': 'Ngày FI',
  'pages.sourceTransaction.updatedAt': 'Cập nhật',
  'pages.sourceTransaction.actions': 'Thao tác',
  'pages.sourceTransaction.create': 'Thêm mới',
  'pages.sourceTransaction.update': 'Cập nhật',
  'pages.sourceTransaction.cancel': 'Hủy',
  'pages.sourceTransaction.close': 'Đóng',
  'pages.sourceTransaction.details': 'Chi tiết',
  'pages.sourceTransaction.createForm.title': 'Thêm giao dịch nguồn',
  'pages.sourceTransaction.updateForm.title': 'Sửa giao dịch nguồn',
  'pages.sourceTransaction.delete.confirm': 'Xóa mục này?',
  'pages.sourceTransaction.delete.ok': 'Xóa',
  'pages.sourceTransaction.delete.cancel': 'Hủy',
  'pages.sourceTransaction.categoryName': 'Danh mục',
  'pages.sourceTransaction.productGroupName': 'Nhóm SP',
  'pages.sourceTransaction.subCategoryName': 'Danh mục phụ',
  'pages.sourceTransaction.countryName': 'Quốc gia',
  'pages.sourceTransaction.marketName': 'Thị trường',
  'pages.sourceTransaction.merge': 'Gộp',
  'pages.sourceTransaction.remainIQCOfferedQuantity': 'SL giao IQC còn lại',
  'pages.sourceTransaction.remainInlineOfferedQuantity': 'SL giao Inline còn lại',
  'pages.sourceTransaction.remainPreFinalOfferedQuantity': 'SL giao Pre-Final còn lại',
  'pages.sourceTransaction.remainFinalOfferedQuantity': 'SL giao Final còn lại',

  // QC Definition
  'pages.qcDefinition.title': 'Tiêu chuẩn chất lượng',
  'pages.qcDefinition.code': 'Mã',
  'pages.qcDefinition.name': 'Tên tiêu chuẩn',
  'pages.qcDefinition.type': 'Loại',
  'pages.qcDefinition.type.placeholder': 'Chọn loại',
  'pages.qcDefinition.status': 'Trạng thái',
  'pages.qcDefinition.status.placeholder': 'Chọn trạng thái',
  'pages.qcDefinition.status.saved': 'Đã lưu',
  'pages.qcDefinition.status.pending': 'Chờ xử lý',
  'pages.qcDefinition.status.confirmed': 'Đã xác nhận',
  'pages.qcDefinition.product': 'Sản phẩm',
  'pages.qcDefinition.product.placeholder': 'Chọn sản phẩm',
  'pages.qcDefinition.productGroup': 'Nhóm SP',
  'pages.qcDefinition.productGroup.placeholder': 'Chọn nhóm SP',
  'pages.qcDefinition.category': 'Danh mục',
  'pages.qcDefinition.category.placeholder': 'Chọn danh mục',
  'pages.qcDefinition.customer': 'Khách hàng',
  'pages.qcDefinition.customer.placeholder': 'Chọn khách hàng',
  'pages.qcDefinition.supplier': 'Nhà cung cấp',
  'pages.qcDefinition.supplier.placeholder': 'Chọn nhà cung cấp',
  'pages.qcDefinition.process': 'Công đoạn',
  'pages.qcDefinition.process.placeholder': 'Chọn công đoạn',
  'pages.qcDefinition.country': 'Quốc gia',
  'pages.qcDefinition.country.placeholder': 'Chọn quốc gia',
  'pages.qcDefinition.destination': 'Điểm đến',
  'pages.qcDefinition.destination.placeholder': 'Chọn điểm đến',
  'pages.qcDefinition.market': 'Thị trường',
  'pages.qcDefinition.market.placeholder': 'Chọn thị trường',
  'pages.qcDefinition.defectConversion': 'Quy đổi lỗi',
  'pages.qcDefinition.isActive': 'Hoạt động',
  'pages.qcDefinition.updatedAt': 'Cập nhật',
  'pages.qcDefinition.actions': 'Thao tác',
  'pages.qcDefinition.create': 'Thêm mới',
  'pages.qcDefinition.update': 'Cập nhật',
  'pages.qcDefinition.cancel': 'Hủy',
  'pages.qcDefinition.close': 'Đóng',
  'pages.qcDefinition.details': 'Chi tiết',
  'pages.qcDefinition.createForm.title': 'Thêm Tiêu chuẩn chất lượng',
  'pages.qcDefinition.updateForm.title': 'Cập nhật Tiêu chuẩn chất lượng',
  'pages.qcDefinition.delete.confirm': 'Xóa Tiêu chuẩn này?',
  'pages.qcDefinition.delete.ok': 'Xóa',
  'pages.qcDefinition.delete.cancel': 'Hủy',
  'pages.qcDefinition.inspectionType': 'Loại kiểm tra',
  'pages.qcDefinition.inspectionType.placeholder': 'Chọn loại kiểm tra',
  'pages.qcDefinition.qcDefinitionType': 'Loại Tiêu chuẩn',
  'pages.qcDefinition.qcDefinitionType.placeholder': 'Chọn loại tiêu chuẩn',
  'pages.qcDefinition.judgementType': 'Loại đánh giá',
  'pages.qcDefinition.judgementType.placeholder': 'Chọn loại đánh giá',
  'pages.qcDefinition.value': 'Giá trị',
  'pages.qcDefinition.value.placeholder': 'Nhập giá trị',

  // Defect Group
  'pages.defectGroup.title': 'Nhóm lỗi',
  'pages.defectGroup.code': 'Mã',
  'pages.defectGroup.name': 'Tên nhóm',
  'pages.defectGroup.isActive': 'Hoạt động',
  'pages.defectGroup.updatedAt': 'Cập nhật',
  'pages.defectGroup.actions': 'Thao tác',
  'pages.defectGroup.create': 'Thêm mới',
  'pages.defectGroup.update': 'Cập nhật',
  'pages.defectGroup.cancel': 'Hủy',
  'pages.defectGroup.close': 'Đóng',
  'pages.defectGroup.details': 'Chi tiết',
  'pages.defectGroup.createForm.title': 'Thêm nhóm lỗi',
  'pages.defectGroup.updateForm.title': 'Cập nhật nhóm lỗi',
  'pages.defectGroup.delete.confirm': 'Xóa nhóm lỗi này?',
  'pages.defectGroup.delete.ok': 'Xóa',
  'pages.defectGroup.delete.cancel': 'Hủy',

  // Defect Action
  'pages.defectAction.title': 'Biện pháp Khắc phục/Phòng ngừa',
  'pages.defectAction.code': 'Mã',
  'pages.defectAction.name': 'Tên biện pháp',
  'pages.defectAction.type': 'Loại',
  'pages.defectAction.isActive': 'Hoạt động',
  'pages.defectAction.description': 'Mô tả',
  'pages.defectAction.organizationDetailId': 'Phòng ban',
  'pages.defectAction.employeeId': 'Nhân viên',
  'pages.defectAction.updatedAt': 'Cập nhật',
  'pages.defectAction.actions': 'Thao tác',
  'pages.defectAction.create': 'Thêm mới',
  'pages.defectAction.update': 'Cập nhật',
  'pages.defectAction.cancel': 'Hủy',
  'pages.defectAction.close': 'Đóng',
  'pages.defectAction.details': 'Chi tiết',
  'pages.defectAction.createForm.title': 'Thêm biện pháp',
  'pages.defectAction.updateForm.title': 'Cập nhật biện pháp',
  'pages.defectAction.delete.confirm': 'Xóa biện pháp này?',
  'pages.defectAction.delete.ok': 'Xóa',
  'pages.defectAction.delete.cancel': 'Hủy',

  // Defect Reason
  'pages.defectReason.title': 'Nguyên nhân lỗi',
  'pages.defectReason.code': 'Mã',
  'pages.defectReason.name': 'Nguyên nhân',
  'pages.defectReason.isActive': 'Hoạt động',
  'pages.defectReason.updatedAt': 'Cập nhật',
  'pages.defectReason.actions': 'Thao tác',
  'pages.defectReason.create': 'Thêm mới',
  'pages.defectReason.update': 'Cập nhật',
  'pages.defectReason.cancel': 'Hủy',
  'pages.defectReason.close': 'Đóng',
  'pages.defectReason.details': 'Chi tiết',
  'pages.defectReason.createForm.title': 'Thêm nguyên nhân lỗi',
  'pages.defectReason.updateForm.title': 'Cập nhật nguyên nhân lỗi',
  'pages.defectReason.delete.confirm': 'Xóa nguyên nhân này?',
  'pages.defectReason.delete.ok': 'Xóa',
  'pages.defectReason.delete.cancel': 'Hủy',

  // Defect Conversion
  'pages.defectConversion.title': 'Quy đổi lỗi',
  'pages.defectConversion.code': 'Mã',
  'pages.defectConversion.name': 'Tên',
  'pages.defectConversion.conversionUnit': 'Đơn vị quy đổi',
  'pages.defectConversion.majorConversion': 'Quy đổi lỗi Nặng',
  'pages.defectConversion.minorConversion': 'Quy đổi lỗi Nhẹ',
  'pages.defectConversion.isActive': 'Hoạt động',
  'pages.defectConversion.updatedAt': 'Cập nhật',
  'pages.defectConversion.actions': 'Thao tác',
  'pages.defectConversion.create': 'Thêm mới',
  'pages.defectConversion.update': 'Cập nhật',
  'pages.defectConversion.cancel': 'Hủy',
  'pages.defectConversion.close': 'Đóng',
  'pages.defectConversion.details': 'Chi tiết',
  'pages.defectConversion.createForm.title': 'Thêm quy đổi lỗi',
  'pages.defectConversion.updateForm.title': 'Cập nhật quy đổi lỗi',
  'pages.defectConversion.delete.confirm': 'Xóa quy đổi này?',
  'pages.defectConversion.delete.ok': 'Xóa',
  'pages.defectConversion.delete.cancel': 'Hủy',

  // Report Template
  'pages.reportTemplate.title': 'Chi tiết mẫu báo cáo',
  'pages.reportTemplate.code': 'Mã',
  'pages.reportTemplate.name': 'Tên',
  'pages.reportTemplate.applicableTo': 'Áp dụng cho',
  'pages.reportTemplate.reportType': 'Loại báo cáo',
  'pages.reportTemplate.outputFormat': 'Định dạng xuất',
  'pages.reportTemplate.templateKind': 'Loại mẫu',
  'pages.reportTemplate.url': 'URL',
  'pages.reportTemplate.metadataJson': 'Metadata JSON',
  'pages.reportTemplate.description': 'Mô tả',
  'pages.reportTemplate.isActive': 'Hoạt động',
  'pages.reportTemplate.updatedAt': 'Cập nhật',
  'pages.reportTemplate.actions': 'Thao tác',
  'pages.reportTemplate.create': 'Thêm mới',
  'pages.reportTemplate.update': 'Cập nhật',
  'pages.reportTemplate.cancel': 'Hủy',
  'pages.reportTemplate.close': 'Đóng',
  'pages.reportTemplate.details': 'Chi tiết',
  'pages.reportTemplate.createForm.title': 'Thêm mẫu báo cáo',
  'pages.reportTemplate.updateForm.title': 'Cập nhật mẫu báo cáo',
  'pages.reportTemplate.delete.confirm': 'Xóa mẫu báo cáo này?',
  'pages.reportTemplate.delete.ok': 'Xóa',
  'pages.reportTemplate.delete.cancel': 'Hủy',
  'pages.reportTemplate.upload': 'Tải lên tệp',
  'pages.reportTemplate.upload.success': 'Tải lên tệp thành công',
  'pages.reportTemplate.upload.error': 'Tải lên tệp thất bại',
  'pages.reportTemplate.upload.invalidWord': 'Vui lòng tải lên tệp Word (.doc hoặc .docx)',
  'pages.reportTemplate.upload.invalidExcel': 'Vui lòng tải lên tệp Excel (.xls hoặc .xlsx)',
  'pages.reportTemplate.currentUrl': 'URL hiện tại',
  'pages.reportTemplate.url.required': 'URL là bắt buộc. Vui lòng tải lên tệp.',

  // Report Template - Docs
  'pages.reportTemplate.templateDesign': 'Hướng dẫn thiết kế mẫu báo cáo',

  // Defect List
  'pages.defectList.title': 'Danh sách lỗi',
  'pages.defectList.code': 'Mã',
  'pages.defectList.name': 'Tên danh sách',
  'pages.defectList.isActive': 'Hoạt động',
  'pages.defectList.description': 'Mô tả',
  'pages.defectList.category': 'Danh mục',
  'pages.defectList.customer': 'Khách hàng',
  'pages.defectList.process': 'Công đoạn',
  'pages.defectList.defectConversion': 'Quy đổi lỗi',
  'pages.defectList.updatedAt': 'Cập nhật',
  'pages.defectList.actions': 'Thao tác',
  'pages.defectList.create': 'Thêm mới',
  'pages.defectList.update': 'Cập nhật',
  'pages.defectList.cancel': 'Hủy',
  'pages.defectList.close': 'Đóng',
  'pages.defectList.details': 'Chi tiết',
  'pages.defectList.createForm.title': 'Thêm danh sách lỗi',
  'pages.defectList.updateForm.title': 'Cập nhật danh sách lỗi',
  'pages.defectList.delete.confirm': 'Xóa danh sách này?',
  'pages.defectList.delete.ok': 'Xóa',
  'pages.defectList.delete.cancel': 'Hủy',
  'pages.defectList.detailsTable': 'Chi tiết danh sách lỗi',
  'pages.defectList.detail.defect': 'Lỗi',
  'pages.defectList.detail.sequence': 'Thứ tự',
  'pages.defectList.detail.delete.confirm': 'Xóa mục này?',

  // Defect List tabs
  'pages.defectList.tabs.details': 'Chi tiết',
  'pages.defectList.tabs.conditions': 'Điều kiện',
  'pages.defectList.addDetail': 'Thêm lỗi',

  // Defect
  'pages.defect.title': 'Thư viện lỗi',
  'pages.defect.code': 'Mã lỗi',
  'pages.defect.name': 'Tên lỗi',
  'pages.defect.isActive': 'Hoạt động',
  'pages.defect.types': 'Loại',
  'pages.defect.defectGroup': 'Nhóm lỗi',
  'pages.defect.description': 'Mô tả',
  'pages.defect.organizationDetail': 'Tổ chức',
  'pages.defect.employee': 'Nhân viên',
  'pages.defect.updatedAt': 'Cập nhật',
  'pages.defect.actions': 'Thao tác',
  'pages.defect.create': 'Thêm mới',
  'pages.defect.update': 'Cập nhật',
  'pages.defect.cancel': 'Hủy',
  'pages.defect.close': 'Đóng',
  'pages.defect.details': 'Chi tiết',
  'pages.defect.createForm.title': 'Thêm lỗi mới',
  'pages.defect.updateForm.title': 'Cập nhật lỗi',
  'pages.defect.delete.confirm': 'Xóa lỗi này?',
  'pages.defect.delete.ok': 'Xóa',
  'pages.defect.delete.cancel': 'Hủy',
  'pages.defect.deleteConfirm': 'Xác nhận Xóa?',
  
  // Defect tabs
  'pages.defect.tabs.reasons': 'Nguyên nhân',
  'pages.defect.tabs.actions': 'Biện pháp',
  'pages.defect.tabs.files': 'Đính kèm',
  'pages.defect.tabs.languages': 'Đa ngôn ngữ',
  
  // Defect reasons
  'pages.defect.reasonsTable': 'Nguyên nhân',
  'pages.defect.addReason': 'Thêm nguyên nhân',
  'pages.defect.reason.defectReason': 'Nguyên nhân',
  'pages.defect.reason.code': 'Mã',
  'pages.defect.reason.name': 'Tên',
  
  // Defect actions
  'pages.defect.actionsTable': 'Biện pháp',
  'pages.defect.addAction': 'Thêm biện pháp',
  'pages.defect.action.defectAction': 'Biện pháp',
  'pages.defect.action.type': 'Loại',
  'pages.defect.action.code': 'Mã',
  'pages.defect.action.name': 'Tên',
  
  // Defect files
  'pages.defect.filesTable': 'File đính kèm',
  'pages.defect.addFile': 'Thêm tài liệu',
  'pages.defect.file.name': 'Tên',
  'pages.defect.file.type': 'Loại',
  'pages.defect.file.url': 'Link',
  'pages.defect.file.description': 'Mô tả',
  'pages.defect.file.view': 'Xem',
  'pages.defect.file.upload': 'Tải lên',
  
  // Defect languages
  'pages.defect.languagesTable': 'Đa ngôn ngữ',
  'pages.defect.addLanguage': 'Thêm ngôn ngữ',
  'pages.defect.language.language': 'Ngôn ngữ',
  'pages.defect.language.value': 'Giá trị',
  'pages.defect.language.description': 'Mô tả',

  // Inspection Request
  'pages.inspectionRequest.code': 'Mã phiếu',
  'pages.inspectionRequest.sourceType': 'Nguồn',
  'pages.inspectionRequest.status': 'Trạng thái',
  'pages.inspectionRequest.inspectionType': 'Loại kiểm tra',
  'pages.inspectionRequest.company': 'Công ty',
  'pages.inspectionRequest.site': 'Địa điểm',
  'pages.inspectionRequest.qcDefinition': 'Tiêu chuẩn chất lượng',
  'pages.inspectionRequest.checklist': 'Danh sách kiểm',
  'pages.inspectionRequest.defectList': 'Danh sách lỗi',
  'pages.inspectionRequest.targetDate': 'Hạn chót',
  'pages.inspectionRequest.scheduleDate': 'Ngày kế hoạch',
  'pages.inspectionRequest.employee': 'Nhân viên',
  'pages.inspectionRequest.reason': 'Lý do',
  'pages.inspectionRequest.createdBy': 'Người tạo',
  'pages.inspectionRequest.createdAt': 'Ngày tạo',
  'pages.inspectionRequest.updatedAt': 'Cập nhật',
  'pages.inspectionRequest.actions': 'Hành động',
  'pages.inspectionRequest.create': 'Thêm mới',
  'pages.inspectionRequest.update': 'Cập nhật',
  'pages.inspectionRequest.delete': 'Xóa',
  'pages.inspectionRequest.cancel': 'Hủy',
  'pages.inspectionRequest.delete.confirm': 'Xóa yêu cầu này?',
  'pages.inspectionRequest.createForm.title': 'Thêm yêu cầu kiểm tra',
  'pages.inspectionRequest.updateForm.title': 'Cập nhật yêu cầu kiểm tra',
  'pages.inspectionRequest.details': 'Chi tiết',
  'pages.inspectionRequest.placeholder.sourceType': 'Chọn nguồn',
  'pages.inspectionRequest.placeholder.status': 'Chọn trạng thái',
  'pages.inspectionRequest.placeholder.inspectionType': 'Chọn loại kiểm tra',
  'pages.inspectionRequest.placeholder.company': 'Chọn công ty',
  'pages.inspectionRequest.placeholder.site': 'Chọn địa điểm',
  'pages.inspectionRequest.placeholder.qcDefinition': 'Chọn tiêu chuẩn chất lượng',
  'pages.inspectionRequest.placeholder.checklist': 'Chọn danh sách kiểm',
  'pages.inspectionRequest.placeholder.defectList': 'Chọn danh sách lỗi',
  'pages.inspectionRequest.placeholder.employee': 'Chọn nhân viên',
  'pages.inspectionRequest.placeholder.scheduleDate': 'Chọn ngày kế hoạch',
  'pages.inspectionRequest.placeholder.targetDate': 'Chọn hạn chót',
  'pages.inspectionRequest.placeholder.reason': 'Nhập lý do',
  'pages.inspectionRequest.targetDate.required': 'Hạn chót là bắt buộc',
  'pages.inspectionRequest.detailsTable': 'Chi tiết yêu cầu',
  'pages.inspectionRequest.detail.sourceTransaction': 'Giao dịch nguồn',
  'pages.inspectionRequest.detail.inspectedQuantity': 'SL kiểm tra',
  'pages.inspectionRequest.equilaventAcceptLimit': 'Giới hạn lỗi tương đương',
  'pages.inspectionRequest.majorAcceptLimit': 'Giới hạn lỗi Nặng',
  'pages.inspectionRequest.minorAcceptLimit': ' Giới hạn lỗi Nhẹ',
  'pages.inspectionRequest.judgementType': 'Loại đánh giá',
  'pages.inspectionRequest.detail.placeholder.sourceTransaction': 'Chọn giao dịch nguồn',
  'pages.inspectionRequest.detail.placeholder.inspectedQuantity': 'Nhập số lượng',
  'pages.inspectionRequest.detail.delete.confirm': 'Xóa dòng này?',
  'pages.inspectionRequest.detail.duplicateWarning': 'Giao dịch nguồn này đã được thêm!',
  'pages.inspectionRequest.detail.duplicateError': 'Không thể gửi do trùng lặp lô hàng',
  'pages.inspectionRequest.detail.duplicateAlert': 'Phát hiện trùng lặp lô hàng',
  'pages.inspectionRequest.detail.duplicateAlertDescription': 'Mỗi lô hàng chỉ được thêm một lần. Hãy kiểm tra lại.',
  
  // Bulk actions
  'pages.inspectionRequest.assign': 'Phân công',
  'pages.inspectionRequest.assign.title': 'Phân công nhân viên',
  'pages.inspectionRequest.assign.ok': 'Xác nhận',
  'pages.inspectionRequest.employee.required': 'Vui lòng chọn nhân viên',
  'pages.inspectionRequest.scheduleDate.required': 'Vui lòng chọn ngày kế hoạch',
  'pages.inspectionRequest.status.cancelled': 'Đã hủy',
  'pages.inspectionRequest.status.bypass': 'Bỏ qua',
  'pages.inspectionRequest.status.inProgress': 'Đang thực hiện',
  'pages.inspectionRequest.status.reason.required': 'Vui lòng nhập lý do',
  'pages.inspectionRequest.status.reason.label': 'Lý do (bắt buộc):',
  'pages.inspectionRequest.status.reason.placeholder': 'Nhập lý do đổi trạng thái',
  'pages.inspectionRequest.status..title': 'Đổi trạng thái',
  'pages.inspectionRequest.status.saved.title': 'Chuyển sang: Đã lưu',
  'pages.inspectionRequest.status.confirmed.title': 'Chuyển sang: Đã xác nhận',
  'pages.inspectionRequest.status.inprogress.title': 'Chuyển sang: Đang thực hiện',
  'pages.inspectionRequest.status.cancelled.title': 'Chuyển sang: Đã hủy',
  'pages.inspectionRequest.status.bypass.title': 'Chuyển sang: Bỏ qua',
  'pages.inspectionRequest.status.completed.title': 'Chuyển sang: Hoàn thành',
  'pages.inspectionRequest.drawer.add': 'Thêm yêu cầu',
  'pages.inspectionRequest.drawer.update': 'Cập nhật yêu cầu',
  'pages.inspectionRequest.save': 'Lưu',
  'pages.inspectionRequest.selectSourceTransaction': 'Chọn lô hàng',
  'pages.inspectionRequest.addSelected': 'Thêm ({count})',
  'pages.inspectionRequest.addSelectedMerge': 'Thêm đã gộp ({count})',
  'pages.inspectionRequest.selected': 'Đã chọn {count}',
  'pages.inspectionRequest.delete.record.confirm': 'Xóa bản ghi này?',

  // Inspection Request Coordinator (giống inspectionRequest)
  'pages.inspectionRequestCoordinator.code': 'Mã phiếu',
  'pages.inspectionRequestCoordinator.sourceType': 'Nguồn',
  'pages.inspectionRequestCoordinator.status': 'Trạng thái',
  'pages.inspectionRequestCoordinator.inspectionType': 'Loại kiểm tra',
  'pages.inspectionRequestCoordinator.company': 'Công ty',
  'pages.inspectionRequestCoordinator.companyId': 'Công ty',
  'pages.inspectionRequestCoordinator.site': 'Địa điểm',
  'pages.inspectionRequestCoordinator.siteId': 'Địa điểm',
  'pages.inspectionRequestCoordinator.qcDefinition': 'Tiêu chuẩn chất lượng',
  'pages.inspectionRequestCoordinator.qcDefinitionId': 'Tiêu chuẩn chất lượng',
  'pages.inspectionRequestCoordinator.checklist': 'Danh sách kiểm',
  'pages.inspectionRequestCoordinator.checklistId': 'Danh sách kiểm',
  'pages.inspectionRequestCoordinator.defectList': 'Danh sách lỗi',
  'pages.inspectionRequestCoordinator.defectListId': 'Danh sách lỗi',
  'pages.inspectionRequestCoordinator.targetDate': 'Hạn chót',
  'pages.inspectionRequestCoordinator.scheduleDate': 'Ngày kế hoạch',
  'pages.inspectionRequestCoordinator.employee': 'Nhân viên',
  'pages.inspectionRequestCoordinator.employeeId': 'Nhân viên',
  'pages.inspectionRequestCoordinator.reason': 'Lý do',
  'pages.inspectionRequestCoordinator.sourceTransaction': 'Lô hàng',
  'pages.inspectionRequestCoordinator.sourceTransactionId': 'Lô hàng',
  'pages.inspectionRequestCoordinator.productCode': 'Mã sản phẩm',
  'pages.inspectionRequestCoordinator.productId': 'Sản phẩm',
  'pages.inspectionRequestCoordinator.orderQuantity': 'Số lượng đơn hàng',
  'pages.inspectionRequestCoordinator.offeredQuantity': 'Số lượng đề nghị',
  'pages.inspectionRequestCoordinator.inspectedQuantity': 'SL kiểm tra',
  'pages.inspectionRequestCoordinator.equilaventAcceptLimit': 'Giới hạn lỗi tương đương',
  'pages.inspectionRequestCoordinator.majorAcceptLimit': 'Giới hạn lỗi Nặng', 
  'pages.inspectionRequestCoordinator.minorAcceptLimit': 'Giới hạn lỗi Nhẹ',
  'pages.inspectionRequestCoordinator.judgementType': 'Loại đánh giá',
  'pages.inspectionRequestCoordinator.createdBy': 'Người tạo',
  'pages.inspectionRequestCoordinator.createdAt': 'Ngày tạo',
  'pages.inspectionRequestCoordinator.updatedAt': 'Cập nhật',
  'pages.inspectionRequestCoordinator.fiDate': 'Ngày FI',
  'pages.inspectionRequestCoordinator.actions': 'Hành động',
  'pages.inspectionRequestCoordinator.details': 'Chi tiết',
  'pages.inspectionRequestCoordinator.process': 'Quy trình',
  'pages.inspectionRequestCoordinator.processId': 'Quy trình',
  'pages.inspectionRequestCoordinator.create': 'Thêm',
  'pages.inspectionRequestCoordinator.update': 'Cập nhật',
  'pages.inspectionRequestCoordinator.delete': 'Xóa',
  'pages.inspectionRequestCoordinator.delete.confirm': 'Xóa các mục đã chọn?',
  'pages.inspectionRequestCoordinator.cancel': 'Hủy',
  'pages.inspectionRequestCoordinator.confirm': 'Xác nhận',
  'pages.inspectionRequestCoordinator.selected': 'Đã chọn {count}',
  'pages.inspectionRequestCoordinator.unselect': 'Bỏ chọn',
  'pages.inspectionRequestCoordinator.assign': 'Phân công',
  'pages.inspectionRequestCoordinator.assign.title': 'Phân công nhân viên',
  'pages.inspectionRequestCoordinator.assign.ok': 'Xác nhận',
  'pages.inspectionRequestCoordinator.employee.required': 'Vui lòng chọn nhân viên',
  'pages.inspectionRequestCoordinator.scheduleDate.required': 'Vui lòng chọn ngày kế hoạch',
  'pages.inspectionRequestCoordinator.placeholder.employee': 'Chọn nhân viên',
  'pages.inspectionRequestCoordinator.placeholder.scheduleDate': 'Chọn ngày kế hoạch',
  'pages.inspectionRequestCoordinator.status.cancelled': 'Đã hủy',
  'pages.inspectionRequestCoordinator.status.bypass': 'Bỏ qua',
  'pages.inspectionRequestCoordinator.status.inProgress': 'Bắt đầu',
  'pages.inspectionRequestCoordinator.status.reason.required': 'Nhập lý do',
  'pages.inspectionRequestCoordinator.status.reason.label': 'Lý do (bắt buộc):',
  'pages.inspectionRequestCoordinator.status.reason.placeholder': 'Nhập lý do đổi trạng thái',
  'pages.inspectionRequestCoordinator.status.change.title': 'Đổi trạng thái',
  'pages.inspectionRequestCoordinator.status.cancelled.title': 'Chuyển sang: Đã hủy',
  'pages.inspectionRequestCoordinator.status.bypass.title': 'Chuyển sang: Bỏ qua',
  'pages.inspectionRequestCoordinator.status.inprogress.title': 'Chuyển trạng thái sang Đang thực hiện',
  'pages.inspectionRequestCoordinator.status.saved.title': 'Chuyển trạng thái sang Đã lưu',
  'pages.inspectionRequestCoordinator.status.confirmed.title': 'Chuyển trạng thái sang Đã xác nhận',
  'pages.inspectionRequestCoordinator.status.completed.title': 'Chuyển trạng thái sang Hoàn thành',
  'pages.inspectionRequestCoordinator.message.assign.success': 'Phân công thành công {count} phiếu',
  'pages.inspectionRequestCoordinator.message.assign.failed': 'Phân công thất bại!',
  'pages.inspectionRequestCoordinator.message.statusChange.success': 'Đã đổi trạng thái {status} cho {count} phiếu',
  'pages.inspectionRequestCoordinator.message.statusChange.failed': 'Đổi trạng thái thất bại!',
  'pages.inspectionRequestCoordinator.message.delete.success': 'Đã xóa {count} phiếu',
  'pages.inspectionRequestCoordinator.message.delete.errors': 'Lỗi xóa:',
  'pages.inspectionRequestCoordinator.message.delete.failed': 'Xóa thất bại!',
  'pages.inspectionRequestCoordinator.tooltip.cannotDelete': 'Không thể xóa các bản ghi khác trạng thái',
  'pages.inspectionRequestCoordinator.drawer.add': 'Thêm yêu cầu',
  'pages.inspectionRequestCoordinator.drawer.update': 'Cập nhật yêu cầu',
  'pages.inspectionRequestCoordinator.save': 'Lưu',
  'pages.inspectionRequestCoordinator.delete.record.confirm': 'Xóa bản ghi này?',
  'pages.inspectionRequestCoordinator.placeholder.code': 'Nhập mã',
  'pages.inspectionRequestCoordinator.placeholder.sourceTransaction': 'Chọn lô hàng',
  'pages.inspectionRequestCoordinator.placeholder.company': 'Chọn công ty',
  'pages.inspectionRequestCoordinator.placeholder.qcDefinition': 'Chọn tiêu chuẩn chất lượng',
  'pages.inspectionRequestCoordinator.validation.code.required': 'Mã là bắt buộc',
  'pages.inspectionRequestCoordinator.validation.sourceType.required': 'Chọn loại nguồn',
  'pages.inspectionRequestCoordinator.validation.inspectionType.required': 'Chọn loại kiểm tra',
  'pages.inspectionRequestCoordinator.validation.sourceTransaction.required': 'Chọn lô hàng',
  'pages.inspectionRequestCoordinator.validation.company.required': 'Chọn công ty',
  'pages.inspectionRequestCoordinator.validation.qcDefinition.required': 'Chọn tiêu chuẩn chất lượng',
  'pages.inspectionRequestCoordinator.validation.scheduleDate.required': 'Chọn Ngày kế hoạch',
  'pages.inspectionRequestCoordinator.validation.employee.required': 'Chọn Nhân viên',
  'pages.inspectionRequestCoordinator.message.noChanges': 'Không có thay đổi để lưu',
  'pages.inspectionRequestCoordinator.message.save.success': 'Lưu thành công',
  'pages.inspectionRequestCoordinator.message.save.failed': 'Lưu thất bại. Vui lòng thử lại.',
  'pages.inspectionRequestCoordinator.message.validation.failed': 'Vui lòng sửa các lỗi dữ liệu',
  'pages.inspectionRequestCoordinator.message.record.removed': 'Đã xóa bản ghi',
  'pages.inspectionRequestCoordinator.message.record.markedForDeletion': 'Đã đánh dấu xóa. Nhấp Lưu để áp dụng.',
  'pages.inspectionRequestCoordinator.message.rows.added': 'Đã thêm {count} dòng.',
  'pages.inspectionRequestCoordinator.message.mapping.failed': 'Lỗi tải dữ liệu. Vui lòng thử lại.',
  'pages.inspectionRequestCoordinator.loading.mapping': 'Đang tính toán số lượng...',
  'pages.inspectionRequestCoordinator.copy.menu.all': 'Sao chép cho mọi dòng',
  'pages.inspectionRequestCoordinator.copy.menu.below': 'Sao chép cho các dòng bên dưới',
  'pages.inspectionRequestCoordinator.copy.successAll': 'Đã sao chép cho {count} dòng.',
  'pages.inspectionRequestCoordinator.copy.successBelow': 'Đã sao chép cho {count} dòng bên dưới.',
  'pages.inspectionRequestCoordinator.copy.noRowsAll': 'Không có dòng nào để sao chép.',
  'pages.inspectionRequestCoordinator.copy.noRowsBelow': 'Không có dòng bên dưới để sao chép.',

  // Inspection Request Inspector (giống inspectionRequest)
  'pages.inspectionRequestInspector.code': 'Mã phiếu',
  'pages.inspectionRequestInspector.sourceType': 'Nguồn',
  'pages.inspectionRequestInspector.status': 'Trạng thái',
  'pages.inspectionRequestInspector.inspectionType': 'Loại kiểm tra',
  'pages.inspectionRequestInspector.company': 'Công ty',
  'pages.inspectionRequestInspector.companyId': 'Công ty',
  'pages.inspectionRequestInspector.site': 'Địa điểm',
  'pages.inspectionRequestInspector.siteId': 'Địa điểm',
  'pages.inspectionRequestInspector.qcDefinition': 'Tiêu chuẩn chất lượng',
  'pages.inspectionRequestInspector.qcDefinitionId': 'Tiêu chuẩn chất lượng',
  'pages.inspectionRequestInspector.checklistId': 'Danh sách kiểm',
  'pages.inspectionRequestInspector.defectListId': 'Danh sách lỗi',
  'pages.inspectionRequestInspector.sourceTransaction': 'Lô hàng',
  'pages.inspectionRequestInspector.sourceTransactionId': 'Lô hàng',
  'pages.inspectionRequestInspector.productCode': 'Mã sản phẩm',
  'pages.inspectionRequestInspector.productId': 'Sản phẩm',
  'pages.inspectionRequestInspector.inspectedQuantity': 'SL kiểm tra',
  'pages.inspectionRequestInspector.equilaventAcceptLimit': 'Giới hạn lỗi tương đương',
  'pages.inspectionRequestInspector.majorAcceptLimit': 'Giới hạn lỗi Nặng',
  'pages.inspectionRequestInspector.minorAcceptLimit': 'Giới hạn lỗi Nhẹ',
  'pages.inspectionRequestInspector.judgementType': 'Loại đánh giá',
  'pages.inspectionRequestInspector.targetDate': 'Hạn chót',
  'pages.inspectionRequestInspector.scheduleDate': 'Ngày kế hoạch',
  'pages.inspectionRequestInspector.employee': 'Nhân viên',
  'pages.inspectionRequestInspector.employeeId': 'Nhân viên',
  'pages.inspectionRequestInspector.fiDate': 'Ngày FI',
  'pages.inspectionRequestInspector.updatedAt': 'Cập nhật',
  'pages.inspectionRequestInspector.selected': 'Đã chọn {count}',
  'pages.inspectionRequestInspector.unselect': 'Bỏ chọn',
  'pages.inspectionRequestInspector.status.cancelled': 'Đã hủy',
  'pages.inspectionRequestInspector.status.bypass': 'Bỏ qua',
  'pages.inspectionRequestInspector.status.inProgress': 'Bắt đầu',
  'pages.inspectionRequestInspector.status.completed': 'Hoàn thành',
  'pages.inspectionRequestInspector.status.reason.required': 'Nhập lý do',
  'pages.inspectionRequestInspector.status.reason.label': 'Lý do (bắt buộc):',
  'pages.inspectionRequestInspector.status.reason.placeholder': 'Nhập lý do thay đổi trạng thái',
  'pages.inspectionRequestInspector.status.change.title': 'Đổi trạng thái',
  'pages.inspectionRequestInspector.status.cancelled.title': 'Chuyển sang: Đã hủy',
  'pages.inspectionRequestInspector.status.bypass.title': 'Chuyển sang: Bỏ qua',

  // Inspection Result
  'pages.inspectionResult.title': 'Kết quả kiểm tra',
  'pages.inspectionResult.inspectionRequestCode': 'Mã yêu cầu',
  'pages.inspectionResult.inspectionRequestEmployeeId': 'Nhân viên',
  'pages.inspectionResult.productCode': 'Mã sản phẩm',
  'pages.inspectionResult.productId': 'Sản phẩm',
  'pages.inspectionResult.inspectionType': 'Loại kiểm tra',
  'pages.inspectionResult.date': 'Ngày',
  'pages.inspectionResult.status': 'Trạng thái',
  'pages.inspectionResult.offeredCarton': 'Số thùng yêu cầu',
  'pages.inspectionResult.inspectedCarton': 'Số thùng kiểm tra',
  'pages.inspectionResult.judgementStatus': 'Trạng thái đánh giá',
  'pages.inspectionResult.judgementUserId': 'Người đánh giá',
  'pages.inspectionResult.judgementUserName': 'Người đánh giá',
  'pages.inspectionResult.judgementDate': 'Ngày đánh giá',
  'pages.inspectionResult.updatedAt': 'Cập nhật',
  'pages.inspectionResult.actions': 'Thao tác',
  'pages.inspectionResult.update': 'Cập nhật',
  'pages.inspectionResult.cancel': 'Hủy',
  'pages.inspectionResult.close': 'Đóng',
  'pages.inspectionResult.details': 'Chi tiết',
  'pages.inspectionResult.updateForm.title': 'Cập nhật kết quả',
  'pages.inspectionResult.delete.confirm': 'Xóa mục này?',
  'pages.inspectionResult.delete.ok': 'Xóa',
  'pages.inspectionResult.delete.cancel': 'Hủy',
  'pages.inspectionResult.status.approve': 'Phê duyệt',
  'pages.inspectionResult.status.reject': 'Từ chối',
  'pages.inspectionResult.judgementResult': 'Kết luận',
  'pages.inspectionResult.judgementResult.required': 'Kết luận là bắt buộc',
  'pages.inspectionResult.judgementRemark': 'Ghi chú',
  'pages.inspectionResult.mainInfo': 'Thông tin chính',
  'pages.inspectionResult.qcDefinitionCode': 'Mã tiêu chuẩn',
  'pages.inspectionResult.checklistCode': 'Mã danh sách kiểm',
  'pages.inspectionResult.defectListCode': 'Mã danh sách lỗi',
  'pages.inspectionResult.employeeName': 'Nhân viên',
  'pages.inspectionResult.targetDate': 'Hạn chót',
  'pages.inspectionResult.totalDefect': 'Tổng lỗi',
  'pages.inspectionResult.totalEquivalent': 'Tổng lỗi tương đương',

  // Inspection Result - Export
  'pages.inspectionResult.export': 'Xuất báo cáo',
  'pages.inspectionResult.selectReportTemplate': 'Chọn mẫu báo cáo',

  // Report Docs
  'pages.reportDocs.templateDesign.title': 'Hướng dẫn thiết kế mẫu báo cáo',
  'pages.reportDocs.templateDesign.description':
    'Hướng dẫn chi tiết cách thiết kế mẫu báo cáo và sử dụng placeholders cho báo cáo Kết quả kiểm tra.',
  'pages.reportDocs.view': 'Xem',
  'pages.reportDocs.hide': 'Ẩn',
  'pages.reportDocs.placeholder': 'Chọn một tài liệu từ danh sách để xem nội dung.',
  
  // Inspection Result tabs
  'pages.inspectionResult.tabs.summaries': 'Tóm tắt',
  'pages.inspectionResult.tabs.defectColorSizes': 'Lỗi theo Màu/Size',
  'pages.inspectionResult.tabs.checklists': 'Danh sách kiểm',
  'pages.inspectionResult.tabs.defectCapturings': 'Ghi nhận lỗi',
  'pages.inspectionResult.tabs.finalJudgement': 'Kết luận',
  
  // Inspection Result Summary
  'pages.inspectionResult.summary.product': 'Sản phẩm',
  'pages.inspectionResult.summary.color': 'Màu',
  'pages.inspectionResult.summary.size': 'Size',
  'pages.inspectionResult.summary.orderQuantity': 'SL đơn hàng',
  'pages.inspectionResult.summary.offeredQuantity': 'SL yêu cầu',
  'pages.inspectionResult.summary.inspectedQuantity': 'SL kiểm tra',
  'pages.inspectionResult.summary.acceptanceQuantity': 'SL chấp nhận',
  'pages.inspectionResult.summary.equilaventAcceptLimit': 'Giới hạn lỗi tương đương',
  'pages.inspectionResult.summary.majorAcceptLimit': 'Giới hạn lỗi Nặng',
  'pages.inspectionResult.summary.minorAcceptLimit': 'Giới hạn lỗi Nhẹ',
  'pages.inspectionResult.summary.fiDate': 'Ngày FI',
  
  // Inspection Result Final Judgement
  'pages.inspectionResult.finalJudgement.complete': 'Hoàn thành',
  'pages.inspectionResult.finalJudgement.approve': 'Phê duyệt',
  'pages.inspectionResult.finalJudgement.reject': 'Từ chối',
  'pages.inspectionResult.finalJudgement.cancel': 'Hủy',
  'pages.inspectionResult.finalJudgement.files': 'File đính kèm',
  'pages.inspectionResult.finalJudgement.file.manage': 'Quản lý File',
  'pages.inspectionResult.finalJudgement.file.totalCount': 'Tổng: {count}',
  'pages.inspectionResult.finalJudgement.file.selectAll': 'Chọn tất cả',
  'pages.inspectionResult.finalJudgement.file.downloadSelected': 'Tải xuống',
  'pages.inspectionResult.finalJudgement.file.deleteSelected': 'Xóa',
  'pages.inspectionResult.finalJudgement.file.selectedCount': 'Đã chọn: {count}',
  'pages.inspectionResult.finalJudgement.view.table': 'Chế độ bảng',
  'pages.inspectionResult.finalJudgement.view.upload': 'Chế độ tải lên',
  'pages.inspectionResult.finalJudgement.file.manageTitle': 'Tài liệu kết luận',
  'pages.inspectionResult.finalJudgement.file.upload': 'Tải lên',
  'pages.inspectionResult.finalJudgement.files.table': 'Tài liệu kết luận',
  'pages.inspectionResult.finalJudgement.file.name': 'Tên',
  'pages.inspectionResult.finalJudgement.file.placeholder.name': 'Nhập tên',
  'pages.inspectionResult.finalJudgement.file.required.name': 'Tên là bắt buộc',
  'pages.inspectionResult.finalJudgement.file.description': 'Mô tả',
  'pages.inspectionResult.finalJudgement.file.placeholder.description': 'Nhập mô tả',
  'pages.inspectionResult.finalJudgement.file.actions': 'Thao tác',
  'pages.inspectionResult.finalJudgement.file.view': 'Xem',
  'pages.inspectionResult.finalJudgement.file.delete.confirm': 'Xóa file này?',
  
  // Inspection Result Defect Color Size
  'pages.inspectionResult.defectColorSize.product': 'Sản phẩm',
  'pages.inspectionResult.defectColorSize.color': 'Màu',
  'pages.inspectionResult.defectColorSize.size': 'Size',
  'pages.inspectionResult.defectColorSize.status': 'Trạng thái',
  'pages.inspectionResult.defectColorSize.defectQuantity': 'SL lỗi',
  'pages.inspectionResult.defectColorSize.bGroupQuantity': 'SL nhóm B',
  'pages.inspectionResult.defectColorSize.okQuantity': 'Số lượng Đạt',
  'pages.inspectionResult.defectColorSize.confirm': 'Xác nhận',
  'pages.inspectionResult.defectColorSize.approve': 'Phê duyệt',
  'pages.inspectionResult.defectColorSize.reject': 'Từ chối',
  
  // Inspection Result Checklist
  'pages.inspectionResult.checklist.checklistId': 'Danh sách kiểm',
  'pages.inspectionResult.checklist.result': 'Kết quả',
  'pages.inspectionResult.checklist.status': 'Trạng thái',
  'pages.inspectionResult.checklist.confirm': 'Xác nhận',
  'pages.inspectionResult.checklist.approve': 'Phê duyệt',
  'pages.inspectionResult.checklist.reject': 'Từ chối',
  'pages.inspectionResult.checklistDetail.result': 'Kết quả',
  'pages.inspectionResult.checklistDetail.name': 'Tên chi tiết',
  'pages.inspectionResult.checklistDetail.standardValue': 'Tiêu chuẩn',
  'pages.inspectionResult.checklistDetail.sampleSize': 'Cỡ mẫu',
  'pages.inspectionResult.checklistDetail.checkedBy': 'Kiểm tra bởi',
  'pages.inspectionResult.checklistDetail.checkedDate': 'Ngày kiểm tra',
  'pages.inspectionResult.checklistDetail.comment': 'Ghi chú',
  'pages.inspectionResult.checklistDetail.files': 'File',
  'pages.inspectionResult.checklistDetail.files.manage': 'File',
  'pages.inspectionResult.checklistDetail.files.table': 'File đính kèm',
  'pages.inspectionResult.checklistDetail.file.name': 'Tên',
  'pages.inspectionResult.checklistDetail.file.placeholder.name': 'Nhập tên',
  'pages.inspectionResult.checklistDetail.file.description': 'Mô tả',
  'pages.inspectionResult.checklistDetail.file.placeholder.description': 'Nhập mô tả',
  'pages.inspectionResult.checklistDetail.file.actions': 'Thao tác',
  'pages.inspectionResult.checklistDetail.file.view': 'Xem',
  'pages.inspectionResult.checklistDetail.file.upload': 'Tải lên',
  'pages.inspectionResult.checklistDetail.file.delete.confirm': 'Xóa File này?',
  
  // Inspection Result Defect Capturing
  'pages.inspectionResult.defectCapturing.defectListId': 'Danh sách lỗi',
  'pages.inspectionResult.defectCapturing.status': 'Trạng thái',
  'pages.inspectionResult.defectCapturing.confirm': 'Xác nhận',
  'pages.inspectionResult.defectCapturing.approve': 'Phê duyệt',
  'pages.inspectionResult.defectCapturing.reject': 'Từ chối',
  'pages.inspectionResult.defectCapturing.totalEquivalentCount': 'Tổng lỗi tương đương',
  'pages.inspectionResult.defectCapturing.defectJudgementBySystem': 'Hệ thống đánh giá',
  'pages.inspectionResult.defectCapturing.defectJudgementByUser': 'Người dùng đánh giá',
  'pages.inspectionResult.defectCapturingDetail.defectCode': 'Mã lỗi',
  'pages.inspectionResult.defectCapturingDetail.defectName': 'Tên lỗi',
  'pages.inspectionResult.defectCapturingDetail.minorCount': 'Nhẹ',
  'pages.inspectionResult.defectCapturingDetail.majorCount': 'Nặng',
  'pages.inspectionResult.defectCapturingDetail.criticalCount': 'Nghiêm trọng',
  'pages.inspectionResult.defectCapturingDetail.files': 'File',
  'pages.inspectionResult.defectCapturingDetail.files.manage': 'File',
  'pages.inspectionResult.defectCapturingDetail.files.table': 'File đính kèm',
  'pages.inspectionResult.defectCapturingDetail.file.name': 'Tên',
  'pages.inspectionResult.defectCapturingDetail.file.placeholder.name': 'Nhập tên',
  'pages.inspectionResult.defectCapturingDetail.file.description': 'Mô tả',
  'pages.inspectionResult.defectCapturingDetail.file.placeholder.description': 'Nhập mô tả',
  'pages.inspectionResult.defectCapturingDetail.file.actions': 'Thao tác',
  'pages.inspectionResult.defectCapturingDetail.file.view': 'Xem',
  'pages.inspectionResult.defectCapturingDetail.file.upload': 'Tải lên',
  'pages.inspectionResult.defectCapturingDetail.file.delete.confirm': 'Xóa File này?',
  'pages.inspectionResult.defectCapturingDetail.ncr': 'NCR',
  'pages.inspectionResult.defectCapturingDetail.ncr.manage': 'Quản lý NCR',
  'pages.inspectionResult.defectCapturingDetail.ncr.notFound': 'Chưa có NCR',
  'pages.inspectionResult.defectCapturingDetail.ncr.code': 'Mã NCR',
  'pages.inspectionResult.defectCapturingDetail.ncr.status': 'Trạng thái',
  'pages.inspectionResult.defectCapturingDetail.ncr.defectReasonIds': 'Nguyên nhân',
  'pages.inspectionResult.defectCapturingDetail.ncr.defectReasonIds.required': 'Chọn nguyên nhân lỗi',
  'pages.inspectionResult.defectCapturingDetail.ncr.defectActionIds': 'Biện pháp khắc phục',
  'pages.inspectionResult.defectCapturingDetail.ncr.expectedCorrectiveDate': 'Hạn khắc phục',
  'pages.inspectionResult.defectCapturingDetail.ncr.correctivePersonId': 'Người khắc phục',
  'pages.inspectionResult.defectCapturingDetail.ncr.description': 'Mô tả',

  // Inspection Inline
  'pages.inspectionInline.code': 'Mã',
  'pages.inspectionInline.date': 'Ngày',
  'pages.inspectionInline.status': 'Trạng thái',
  'pages.inspectionInline.sourceTransactionCode': 'Giao dịch nguồn',
  'pages.inspectionInline.operationLibraryDetailCode': 'Công đoạn',
  'pages.inspectionInline.employee': 'Nhân viên',
  'pages.inspectionInline.employeeId': 'Nhân viên',
  'pages.inspectionInline.company': 'Công ty',
  'pages.inspectionInline.companyId': 'Công ty',
  'pages.inspectionInline.site': 'Địa điểm',
  'pages.inspectionInline.siteId': 'Địa điểm',
  'pages.inspectionInline.qcDefinition': 'Tiêu chuẩn chất lượng',
  'pages.inspectionInline.qcDefinitionId': 'Tiêu chuẩn chất lượng',
  'pages.inspectionInline.defectList': 'Danh sách lỗi',
  'pages.inspectionInline.defectListId': 'Danh sách lỗi',
  'pages.inspectionInline.resolvedResult': 'Kết quả đã xử lý',
  'pages.inspectionInline.userResult': 'Kết quả người dùng',
  'pages.inspectionInline.operationLibraryDetail': 'Chi tiết công đoạn',
  'pages.inspectionInline.sourceTransaction': 'Giao dịch nguồn',
  'pages.inspectionInline.description': 'Mô tả',
  'pages.inspectionInline.updatedAt': 'Cập nhật lúc',
  'pages.inspectionInline.create': 'Thêm',
  'pages.inspectionInline.update': 'Cập nhật',
  'pages.inspectionInline.delete': 'Xóa',
  'pages.inspectionInline.delete.confirm': 'Bạn có chắc chắn muốn xóa (các) phiếu kiểm định inline đã chọn?',
  'pages.inspectionInline.actions': 'Hành động',
  'pages.inspectionInline.selected': 'Đã chọn {count} mục',
  'pages.inspectionInline.unselect': 'Bỏ chọn',
  'pages.inspectionInline.selectMasters': 'Chọn Dữ liệu chính',
  'pages.inspectionInline.selectOperationLibraryDetail': 'Chọn công đoạn (Chọn một)',
  'pages.inspectionInline.selectComponents': 'Chọn Thành phần (Chọn nhiều)',
  'pages.inspectionInline.selectSourceTransaction': 'Chọn Giao dịch nguồn (Chọn một)',
  'pages.inspectionInline.title.create': 'Tạo Kiểm định Inline',
  'pages.inspectionInline.title.update': 'Cập nhật Kiểm định Inline',
  'pages.inspectionInline.mainInfo': 'Thông tin chính',
  'pages.inspectionInline.systemResult': 'Kết quả hệ thống',
  'pages.inspectionInline.tabs.defectColorSizes': 'Kích thước Màu Lỗi',
  'pages.inspectionInline.defectColorSize.component': 'Thành phần',
  'pages.inspectionInline.defectColorSize.componentUom': 'Đơn vị Thành phần',
  'pages.inspectionInline.defectColorSize.color': 'Màu',
  'pages.inspectionInline.defectColorSize.size': 'Kích thước',
  'pages.inspectionInline.defectColorSize.plannedQuantity': 'Số lượng Kế hoạch',
  'pages.inspectionInline.defectColorSize.outputQuantity': 'Số lượng Đầu ra',
  'pages.inspectionInline.defectColorSize.okQuantity': 'Số lượng OK',
  'pages.inspectionInline.defectColorSize.defectQuantity': 'Số lượng Lỗi',
  'pages.inspectionInline.defectColorSize.bGroupQuantity': 'Số lượng Nhóm B',
  'pages.inspectionInline.tabs.defectCapturings': 'Ghi nhận Lỗi',
  'pages.inspectionInline.defectCapturing.defectListDetail': 'Chi tiết Danh sách Lỗi',
  'pages.inspectionInline.defectCapturing.defectCode': 'Mã Lỗi',
  'pages.inspectionInline.defectCapturing.defectName': 'Tên Lỗi',
  'pages.inspectionInline.defectCapturing.majorCount': 'Nặng',
  'pages.inspectionInline.defectCapturing.minorCount': 'Nhẹ',
  'pages.inspectionInline.defectCapturing.criticalCount': 'Nghiêm trọng',
  'pages.inspectionInline.defectCapturing.description': 'Mô tả',
  'pages.inspectionInline.defectCapturing.totalDefect': 'Tổng lỗi',
  'pages.inspectionInline.defectCapturing.totalEquivalent': 'Tổng lỗi tương đương',
  'pages.inspectionInline.defectCapturing.files': 'Tệp',
  'pages.inspectionInline.defectCapturing.files.view': 'Xem',
  'pages.inspectionInline.defectCapturing.files.manage': 'Quản lý tệp',
  'pages.inspectionInline.defectCapturing.files.view.table': 'Chuyển sang chế độ bảng',
  'pages.inspectionInline.defectCapturing.files.view.upload': 'Chuyển sang chế độ tải lên',
  'pages.inspectionInline.defectCapturing.files.title': 'Tệp ghi nhận lỗi',
  'pages.inspectionInline.defectCapturing.files.table': 'Tệp đính kèm',
  'pages.inspectionInline.defectCapturing.files.noRecord': 'Chưa chọn bản ghi',
  'pages.inspectionInline.defectCapturing.files.name': 'Tên',
  'pages.inspectionInline.defectCapturing.files.placeholder.name': 'Nhập tên tệp',
  'pages.inspectionInline.defectCapturing.files.description': 'Mô tả',
  'pages.inspectionInline.defectCapturing.files.placeholder.description': 'Nhập mô tả',
  'pages.inspectionInline.defectCapturing.files.actions': 'Hành động',
  'pages.inspectionInline.defectCapturing.files.upload': 'Tải lên',
  'pages.inspectionInline.defectCapturing.files.delete.confirm': 'Xóa tệp này?',
  'pages.inspectionInline.placeholder.operationLibraryDetail': 'Chọn Công đoạn',
  'pages.inspectionInline.placeholder.components': 'Chọn Thành phần',

  // Checklist
  'pages.checklist.code': 'Mã',
  'pages.checklist.name': 'Tên danh sách',
  'pages.checklist.description': 'Mô tả',
  'pages.checklist.isActive': 'Hoạt động',
  'pages.checklist.updatedAt': 'Cập nhật',
  'pages.checklist.actions': 'Thao tác',
  'pages.checklist.create': 'Thêm mới',
  'pages.checklist.update': 'Cập nhật',
  'pages.checklist.delete': 'Xóa',
  'pages.checklist.cancel': 'Hủy',
  'pages.checklist.close': 'Đóng',
  'pages.checklist.details': 'Chi tiết',
  'pages.checklist.createForm.title': 'Thêm danh sách kiểm',
  'pages.checklist.updateForm.title': 'Cập nhật danh sách kiểm',
  'pages.checklist.delete.confirm': 'Xóa danh sách này?',
  'pages.checklist.placeholder.description': 'Nhập mô tả',
  'pages.checklist.detailsTable': 'Nội dung kiểm tra',
  'pages.checklist.detail.name': 'Tên nội dung',
  'pages.checklist.detail.placeholder.name': 'Nhập tên',
  'pages.checklist.detail.standardValue': 'Tiêu chuẩn',
  'pages.checklist.detail.placeholder.standard': 'Nhập tiêu chuẩn',
  'pages.checklist.detail.sampleSize': 'Cỡ mẫu',
  'pages.checklist.detail.placeholder.sampleSize': 'Nhập cỡ mẫu',
  'pages.checklist.detail.description': 'Mô tả',
  'pages.checklist.detail.placeholder.description': 'Nhập mô tả',
  'pages.checklist.detail.files': 'File',
  'pages.checklist.detail.addChild': 'Thêm mục con',
  'pages.checklist.detail.delete.confirm': 'Xóa mục này?',
  'pages.checklist.detail.validation.nameRequired': '{count} mục thiếu tên bắt buộc',
  'pages.checklist.detail.files.manage': 'Quản lý file',
  'pages.checklist.detail.files.table': 'File đính kèm',
  'pages.checklist.detail.files.noRecord': 'Chưa chọn file',
  'pages.checklist.detail.file.name': 'Tên',
  'pages.checklist.detail.file.placeholder.name': 'Nhập tên',
  'pages.checklist.detail.file.description': 'Mô tả',
  'pages.checklist.detail.file.placeholder.description': 'Nhập mô tả',
  'pages.checklist.detail.file.actions': 'Thao tác',
  'pages.checklist.detail.file.view': 'Xem',
  'pages.checklist.detail.file.upload': 'Tải lên',
  'pages.checklist.detail.file.delete.confirm': 'Xóa file này?',
  'pages.checklist.detail.file.switchToTable': 'Chế độ bảng',
  'pages.checklist.detail.file.switchToUpload': 'Chế độ tải lên',
  'pages.checklist.detail.file.selectAll': 'Chọn tất cả',
  'pages.checklist.detail.file.downloadSelected': 'Tải xuống',
  'pages.checklist.detail.file.deleteSelected': 'Xóa',
  'pages.checklist.detail.file.download': 'Tải xuống',
  'pages.checklist.detail.file.delete': 'Xóa',
  
  // Mapping -> Liên kết
  'pages.mapping.code': 'Mã',
  'pages.mapping.name': 'Tên liên kết',
  'pages.mapping.type': 'Loại',
  'pages.mapping.refereceId': 'Tham chiếu',
  'pages.mapping.productId': 'Sản phẩm',
  'pages.mapping.productGroupId': 'Nhóm SP',
  'pages.mapping.categoryId': 'Danh mục',
  'pages.mapping.customerId': 'Khách hàng',
  'pages.mapping.supplierId': 'Nhà cung cấp',
  'pages.mapping.processId': 'Công đoạn',
  'pages.mapping.countryId': 'Quốc gia',
  'pages.mapping.marketId': 'Thị trường',
  'pages.mapping.destinationId': 'Điểm đến',
  'pages.mapping.isActive': 'Hoạt động',
  'pages.mapping.updatedAt': 'Cập nhật',
  'pages.mapping.selected': 'Đã chọn {count}',
  'pages.mapping.unselect': 'Bỏ chọn',
  'pages.mapping.add': 'Thêm',
  'pages.mapping.update': 'Cập nhật',
  'pages.mapping.drawer.add': 'Thêm liên kết',
  'pages.mapping.drawer.update': 'Cập nhật liên kết',
  'pages.mapping.cancel': 'Hủy',
  'pages.mapping.close': 'Đóng',
  'pages.mapping.save': 'Lưu',
  'pages.mapping.table.title': 'Bản ghi liên kết',
  'pages.mapping.addRows': 'Thêm dòng',
  'common.save': 'Lưu',
  'common.cancel': 'Hủy',
  'common.close': 'Đóng',
  'common.uploading': 'Đang tải...',
  'common.popup.blocked': 'Vui lòng cho phép Pop-up để mở file.',
  'common.selectAll': 'Chọn tất cả',
  'common.download': 'Tải xuống',
  'common.delete': 'Xóa',
};
